import { baseUrl } from './util';
import request from '@/utils/request';
import { setLocaleQuery } from '@/utils/setLocaleQuery';

// 提交表单 => お問合せ
export const submitCaseQuote = (data: any, locale: string) => {
    return request.post(`${baseUrl(locale)}/casestudy/quote${setLocaleQuery(locale)}`, {
        data,
    });
};

// 提交表单 => お問合せ
export const submitCaseQuoteSimple = (data: any, locale: string) => {
    return request.post(`${baseUrl(locale)}/casestudy/quoteSimple`, {
        data,
    });
};
